import { Table } from 'antd';
import type { TableProps } from 'antd';
import { useMemo } from 'react';

import { CheckCircleFilled } from '@ant-design/icons';
import { Schemas } from '@api-client/generated/types';
import { colors } from '@theme';

import { getPersonByType } from '../helpers';

type Person = Schemas.PersonResponseDto;

type CompanyStructureProps = {
  persons: Person[];
  isLoading: boolean;
};

const successIcon = (isVisible: boolean) =>
  isVisible && (
    <CheckCircleFilled style={{ fontSize: '20px', color: colors.success }} />
  );

/**
 * The cap table, read-only. The delete action is gone with the rest of the onboarding edits: the
 * shareholder register is client data that master-data-service is taking ownership of.
 */
export const CompanyStructure = (props: CompanyStructureProps) => {
  const persons = useMemo(
    () =>
      props.persons.filter(
        (person) =>
          person.companyRelations.isShareholder ||
          person.companyRelations.isDirector
      ),
    [props.persons]
  );

  const columns: TableProps<Person>['columns'] = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (type) => getPersonByType(type),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Shares',
      dataIndex: 'companyRelations',
      key: 'shares',
      render: (companyRelations) => companyRelations.sharesAmount,
    },
    {
      title: 'Director',
      dataIndex: 'companyRelations',
      align: 'center',
      render: (companyRelations) => successIcon(companyRelations.isDirector),
    },
    {
      title: 'Authorized',
      dataIndex: 'companyRelations',
      align: 'center',
      render: (companyRelations) => successIcon(companyRelations.isAuthorized),
    },
  ];

  return (
    <Table<Person>
      rowKey={(row) => row.id}
      columns={columns}
      dataSource={persons}
      loading={props.isLoading}
      pagination={false}
    />
  );
};
